import { isServer } from './isServer' // 导入 isServer 判断

const userAgent = isServer ? '' : navigator.userAgent // 使用 isServer 判断

export const isAndroid = /android/i.test(userAgent)

// iOS 与 iPadOS（桌面 UA）兼容：匹配 iPhone|iPad|iPod 或 Mac 且支持触摸
export const isIOS = /iPhone|iPad|iPod|iPadOS/i.test(userAgent) ||
  (!isServer && /Macintosh/.test(userAgent) && 'ontouchend' in (globalThis as any))

export const isWxMiniProgram = /MicroMessenger/i.test(userAgent) && /miniProgram/i.test(userAgent)

export const isRealseeVRWebview = /realsee/i.test(userAgent)
